import React from "react";
import cx from "clsx";
import VIEW_ICON from "../../../Clients/Documents/icons/view.svg";
import { checkIfPermissionAllowed } from "../../../../Utils";
import classes from "../scss/expirationActionButtons.module.scss";

const ExpirationActionButtons = ({ document, setSelectedDocument }) => {
  const canView = checkIfPermissionAllowed("view-documents");
  const isLocked = Boolean(document.is_lock);

  if (!canView) {
    return null;
  }

  return (
    <div className="flex justify-center gap-8">
      <button
        className={cx("header-unselect-btn", "modal-link", classes.viewIcon)}
        disabled={isLocked}
        onClick={() => {
          if (!isLocked) {
            setSelectedDocument(document);
          }
        }}
      >
        <img
          src={VIEW_ICON}
          className={cx("min-w-16", {
            "cursor-pointer": !isLocked,
            "cursor-not-allowed": isLocked,
          })}
          title="View"
          width={16}
          height={16}
          alt=""
        />
      </button>
    </div>
  );
};

export default ExpirationActionButtons;
